import React from 'react';

function ModalIframe({content}) {
    if(!content.link) {
        return <></>
    }
    const title = content['modalFigcaption'] ? content.modalFigcaption : content.title;

    return <iframe src={content.link} title={title} height="100%" width="100%" allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"/>
}

export default ModalIframe;